Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-apple-widget', function (envelope) {

        var $context = envelope.message.data.context,
            $wrappers = $('.x-apple-widget', $context),
            $buttons = $('.js-applesubmit-button', $wrappers);

        if ($wrappers.length < 1 || $buttons.length < 1) {
            return;
        }
        if (!Vendd.User.AuthProviders.apple) {
            throw new Error('AppleID authentication provider not installed.');
        }

        // Leave the Apple ID login button disabled until the SSO subsystem initialization completes.
        $buttons.prop('disabled', true).addClass('disabled');

        Vendd.User.AuthProviders.apple.init(
            function () {
                $buttons.prop('disabled', false)
                $buttons.on('click', function (e) {
                    Vendd.User.AuthProviders.apple.login();
                    e.preventDefault();
                });
            },
            function (error) {
                throw error;
            }
        );
    });
});
